import '@vendor/javascripts/jquery/jquery.all'
import Rails from '@rails/ujs'

import './common'
import './handle_cookie'
import './notifications'

Rails.start()
